import { Select } from 'antd'
import { ReactNode } from 'react'

export default function StringSelector(props: {
  className?: string | undefined
  items: string[]
  value?: string[]
  mode?: 'multiple' | 'tags' | undefined
  size?: 'small' | 'middle' | 'large'
  // Optional custom label for each item; search still matches the raw item value.
  optionLabel?: (item: string) => ReactNode
  onChange: (value: string[]) => void
}) {
  const items = props.items
  let value = props.value
  if (value?.length === 1 && !value[0]) {
    value = undefined
  }

  const selectOptions = []
  for (const i in items) {
    const item = items[i]
    selectOptions.push({
      value: item,
      label: props.optionLabel ? props.optionLabel(item) : item,
    })
  }

  const onChange = (value: string | string[]) => {
    if (Array.isArray(value)) {
      props.onChange(value)
      return
    }

    props.onChange([value])
  }

  return (
    <Select
      showSearch
      optionFilterProp={props.optionLabel ? 'value' : undefined}
      className={props.className}
      options={selectOptions}
      size={props.size ?? 'middle'}
      mode={props.mode}
      value={value}
      style={{ width: '100%' }}
      onChange={onChange}
    />
  )
}
